export default __webpack_public_path__ + "static/media/frame.555a8bf2.svg";